import * as React from 'react';
import styled from '@emotion/styled';
import { Label } from 'components/common/form-components';
import CopyableCodeBlock from 'components/common/copyable-code-block';

export const intlPrefix = 'organization.settings.notifications';

export const FieldContainer = styled.div`
  min-height: 5em;
`;

export const IdField = (props: { id: string }) => {
  return (
    <FieldContainer>
      <Label id={'id'} />
      <CopyableCodeBlock inline data-e2e="notification-target-id" copyable={{ text: props.id }}>
        {props.id}
      </CopyableCodeBlock>
    </FieldContainer>
  );
};
